import { lazy } from "react";
import { createPortal } from "react-dom";
import { CookieNotice } from "@questy/aura-cl";
import { useEmailMessageModal } from "./hooks/useEmailMessageModal";
import { useIncomingCallSettings } from "./hooks/useIncomingCallSettings";
import { useTaskModal } from "./hooks/useTaskModal";
import { isInAuraContext } from "./pages/desktop/utils";
import useCookieNoticeSettings from "./hooks/useCookieNoticeSettings";
import { CustomScripts } from "@questy/aura-cl";
import { queryClient } from "./index";
import { useMessageThreadModal } from "./hooks/useMessageThreadModal";
const Nav = lazy(() => import("./feature/nav"));
const CallPopover = lazy(() => import("./feature/incoming-call"));

if (process.env.NODE_ENV === "development" && !isInAuraContext()) {
  const devMenuMountPoint = `<div id="aura-menu-root" />`;
  document.body.insertAdjacentHTML("afterbegin", devMenuMountPoint);

  const devIncomingCallMountPoint = `<div id="aura-incoming-call-root" />`;
  document.body.insertAdjacentHTML("afterbegin", devIncomingCallMountPoint);
}

const menuMountPoint = document.getElementById(
  "aura-menu-root"
) as HTMLDivElement;
const incomingCallMountPoint = document.getElementById(
  "aura-incoming-call-root"
) as HTMLDivElement;
const cookieNoticeMountPoint = document.body;

const showMenu = () => {
  if (
    checkUrl("/security/index") ||
    checkUrl("/security/login") ||
    checkUrl("/security/logout")
  ) {
    return false;
  }

  return true;
};

const checkUrl = (url: string) => {
  return document.location.pathname.startsWith(url);
};

/**
 * Komponent pomocniczy pozwalający odseparować montowanie elementów
 * dostępnych globalnie na `window` od elementów interfejsu użytkownika.
 */
const AppAux = () => {
  useEmailMessageModal();
  useTaskModal();
  useMessageThreadModal();
  const dateraEnabled = useIncomingCallSettings();
  const cookieNoticeEnabled = useCookieNoticeSettings();
  const isMenuVisible = showMenu();

  return (
    <>
      {menuMountPoint && isMenuVisible
        ? createPortal(<Nav />, menuMountPoint)
        : null}
      {dateraEnabled && incomingCallMountPoint
        ? createPortal(<CallPopover />, incomingCallMountPoint)
        : null}
      {cookieNoticeEnabled && cookieNoticeMountPoint
        ? createPortal(<CookieNotice />, cookieNoticeMountPoint)
        : null}
      <CustomScripts queryClient={queryClient} />
    </>
  );
};

export default AppAux;
